<template>
	<article class="step-card">
    <p class="step">STEP <span class="red">{{idx + 1}}</span></p>
    <div class="step-card-img-wrapper">
      <img class="step-card-img" :src="img" :alt="description">
    </div>
    <p class="step-card-description" v-html="description"></p>
	</article>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    idx: {
      type: Number,
      required: false,
      default: 0
    },
    img: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.step-card {
  width: 200px;
  padding: 16px;
  text-align: center;
  box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
  border-radius: 6px;
  background-color: #fefefe;
}
.step {
  font-size: 14px;
}
.step-card-img-wrapper {
  margin-top: 16px;
  max-width: 120px;
  width: 100%;
  margin: auto;
  .step-card-img {
    width: 100%;
  }
}
.step-card-description {
  font-size: 14px;
  margin-top: 16px;
}
.red {
  color: #C4283A;
  font-weight: bold;
}
@media screen and (max-width: 896px) {
  .step-card {
    margin: auto;
  }
}
@media screen and (max-width: 480px) {
  .step-card-description {
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/StepCard.vue